import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  getItemsFromQuickOrderCookie,
  updateQuickOrderItemsCookie
} from '../../utils';
import { ADDED_SAVED_LIST_TO_CART } from '@app/store/account/constants';
import { getSessionStorage, removeSessionStorage } from '@app/utils';

const useQuickOrderCookie = (openQOMobileModal, enabled = true) => {
  const [areQOItemsUpdated, setAreQOItemsUpdated] = useState(false);
  const { setFieldValue, values } = useFormikContext();
  const userId = useSelector(s => s.common.userId);

  useEffect(() => {
    const itemsInCookie = getItemsFromQuickOrderCookie(userId);
    if (!areQOItemsUpdated && itemsInCookie && enabled) {
      setFieldValue('items', itemsInCookie);
      if (getSessionStorage(ADDED_SAVED_LIST_TO_CART)) {
        removeSessionStorage(ADDED_SAVED_LIST_TO_CART);
        openQOMobileModal();
      }
    }
    setAreQOItemsUpdated(true);
  }, [enabled, openQOMobileModal, setFieldValue, userId, areQOItemsUpdated]);

  useEffect(() => {
    if (areQOItemsUpdated && enabled) {
      updateQuickOrderItemsCookie(values.items, userId);
    }
  }, [enabled, userId, values.items, areQOItemsUpdated]);
};

export default useQuickOrderCookie;
